import {userHasWritePermissionOverBrandAndFolderType, userIsAdmin} from "./PermissionsHelpers";

export function userCanCreateUser(user) {
    if (user) {
        return userIsAdmin(user);
    }
    return false;
}

export function userCanCreateService(user) {
    if (user) {
        return userIsAdmin(user);
    }
    return false;
}

export function userCanUpdateUser(user, userToEdit) {
    //TODO: maybe disable edit of admin users
    if (user) {
        return userIsAdmin(user);
    }
    return false;
}

export function userCanUpdateService(user, userToEdit) {
    //TODO: maybe disable edit of admin users
    if (user) {
        return userIsAdmin(user);
    }
    return false;
}

export function getUserLabel(user) {
    return user.firstName + " " + user.lastName;
}

export function filterUsersByPermissions(brand, folderType, users) {
    let result = [];
    if (brand && folderType && users.length > 0) {
        result = users.filter(function (tmpUser) {
            const permissionOverBrandAndFolderType = userHasWritePermissionOverBrandAndFolderType(tmpUser, brand, folderType);
            if (permissionOverBrandAndFolderType) {
                //TODO: add check for hst
                return true;
            }
            return false;
        });
    }
    return result;
}
